import { ImageField } from '@sitecore-jss/sitecore-jss-nextjs';

export type County = {
  id: string;
  countyName: string;
  image: ImageField;
  state: string;
  area: string; //Depricated?
};
